<template>
  <div :style="cssVariablesBinding">
    <Theme6BaseTheHeader />

    <div v-if="shouldShowComponent" id="msgboxxWidget" />

    <a v-if="company.company_key === 'harrisonshomes' && !shouldHideWhatsApp"
      href="https://wa.me/447741066215?text=Hi,%20I'm%20on%20the%20Harrison%20Homes%20website%20and%20I%20would%20like%20some%20help..."
      target="_blank"
      rel="noopener"
      aria-label="whatsapp"
      class="whatsapp n-link"
    >
    <svg class="whatsapp-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 170 64" style="enable-background:new 0 0 170 64;" xml:space="preserve">

<g>
	<path class="st0" d="M32,0h106c17.7,0,32,14.3,32,32l0,0c0,17.7-14.3,32-32,32H32C14.3,64,0,49.7,0,32l0,0C0,14.3,14.3,0,32,0z"/>
	
		<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="-682.8823" y1="-162.8126" x2="-682.8823" y2="-163.8126" gradientTransform="matrix(27.2757 0 0 27.3963 18766.5898 4506.2915)">
		<stop offset="0" style="stop-color:#20B038"/>
		<stop offset="1" style="stop-color:#60D66A"/>
	</linearGradient>
	<path class="st1" d="M126.9,45.8l1.9-7c-3.7-6.5-1.5-14.8,5-18.5s14.8-1.5,18.5,5s1.5,14.8-5,18.5c-2.1,1.2-4.4,1.8-6.8,1.8l0,0   c-2.3,0-4.5-0.6-6.5-1.7L126.9,45.8z"/>
	<g transform="translate(0.716 1.004)">
		<path class="st2" d="M125.7,45.3l2-7.3c-3.9-6.7-1.6-15.3,5.2-19.2c6.7-3.9,15.3-1.6,19.2,5.2c3.9,6.7,1.6,15.3-5.2,19.2    c-2.1,1.2-4.6,1.9-7,1.9l0,0c-2.3,0-4.7-0.6-6.7-1.7L125.7,45.3z M133.5,40.8l0.4,0.3c1.8,1.1,3.9,1.6,6,1.6l0,0    c6.5,0,11.7-5.2,11.7-11.7s-5.2-11.7-11.7-11.7s-11.7,5.2-11.7,11.7c0,2.2,0.6,4.4,1.8,6.2l0.3,0.4l-1.2,4.3L133.5,40.8z"/>
	</g>
	<g transform="translate(0.723 1.039)">
		<path class="st3" d="M136.4,25.1c-0.3-0.6-0.5-0.6-0.8-0.6c-0.2,0-0.4,0-0.7,0c-0.4,0-0.7,0.2-0.9,0.4c-0.8,0.8-1.2,1.8-1.2,2.9    c0.1,1.3,0.6,2.6,1.4,3.6c0.2,0.2,2.4,3.9,6,5.3c3,1.2,3.6,0.9,4.2,0.9c1-0.2,1.9-0.8,2.4-1.7c0.2-0.5,0.3-1.1,0.2-1.7    c-0.1-0.1-0.3-0.2-0.7-0.4s-2.1-1-2.4-1.1s-0.6-0.2-0.8,0.2s-0.9,1.1-1.1,1.4s-0.4,0.3-0.8,0.1c-1-0.4-2-1-2.8-1.7s-1.4-1.5-2-2.4    c-0.2-0.4,0-0.5,0.2-0.7s0.4-0.4,0.5-0.6s0.3-0.4,0.4-0.6c0.1-0.2,0.1-0.4,0-0.6C137.3,27.5,136.7,25.8,136.4,25.1z"/>
	</g>
	<g class="st4">
		<path class="st5" d="M37.5,27.8l-3.6,9.4h-0.5l-2.8-6.6l-2.8,6.6h-0.5l-3.6-9.4h1.6l2.3,6.2l2.6-6.4h0.5l2.7,6.4l2.3-6.2H37.5z"/>
		<path class="st5" d="M45.1,32.7V37h-1.5v-4.1c0-1-0.6-1.6-1.5-1.6c-0.9,0-1.6,0.7-1.6,1.6V37h-1.5V26.5h1.5v4.3    c0.5-0.5,1.1-0.8,2-0.8C44.1,30,45.1,31.1,45.1,32.7z"/>
		<path class="st5" d="M52.6,32.8V37h-1.4v-0.8c-0.5,0.6-1.2,0.9-2.2,0.9c-1.4,0-2.4-0.8-2.4-2c0-1.2,1-2,2.5-2h1.9v-0.4    c0-1-0.5-1.5-1.5-1.5c-0.8,0-1.4,0.4-1.9,1l-0.9-0.9c0.7-1,1.7-1.5,2.9-1.5C51.4,30,52.6,30.9,52.6,32.8z M51.1,34.4v-0.1h-1.8    c-0.8,0-1.2,0.3-1.2,0.8c0,0.6,0.5,0.9,1.2,0.9C50.3,36,51.1,35.3,51.1,34.4z"/>
		<path class="st5" d="M58.7,35.8V37c-0.4,0.1-0.8,0.2-1.2,0.2c-1.5,0-2.5-0.7-2.5-2.4v-3.4h-1.1v-1.3H55v-1.8h1.5v1.8h2v1.3h-2v3.2    c0,0.9,0.5,1.2,1.4,1.2C58.1,35.8,58.4,35.8,58.7,35.8z"/>
		<path class="st5" d="M59.6,35.8l0.8-0.9c0.5,0.6,1.1,1,1.9,1c0.6,0,1.1-0.3,1.1-0.8c0-0.4-0.4-0.6-1-0.9L61.8,34    c-1.1-0.5-1.8-1-1.8-2c0-1.3,1.1-2,2.4-2c1,0,1.8,0.4,2.4,1.1L64,31.9c-0.4-0.4-1-0.7-1.6-0.7c-0.5,0-0.9,0.2-0.9,0.7    c0,0.4,0.3,0.5,0.9,0.8L63,33c1.2,0.5,1.9,1.1,1.9,2.1c0,1.4-1.2,2.1-2.5,2.1C61.1,37.2,60.1,36.6,59.6,35.8z"/>
		<path class="st5" d="M72.2,35.5h-4.2L67.4,37h-1.6l4.1-9.4h0.5l4.1,9.4h-1.6L72.2,35.5z M70.1,30.4l-1.6,3.8h3.1L70.1,30.4z"/>
		<path class="st5" d="M83,33.6c0,2.1-1.4,3.6-3.4,3.6c-0.9,0-1.8-0.4-2.3-1v3.4h-1.5v-9.4h1.4v1c0.5-0.7,1.4-1.1,2.4-1.1    C81.6,30,83,31.5,83,33.6z M81.5,33.6c0-1.3-0.9-2.3-2.1-2.3c-1,0-2.1,0.7-2.1,2.2c0,1.6,1,2.3,2.1,2.3    C80.5,35.8,81.5,34.9,81.5,33.6z"/>
		<path class="st5" d="M91.8,33.6c0,2.1-1.4,3.6-3.4,3.6c-0.9,0-1.8-0.4-2.3-1v3.4h-1.5v-9.4H86v1c0.5-0.7,1.4-1.1,2.4-1.1    C90.4,30,91.8,31.5,91.8,33.6z M90.3,33.6c0-1.3-0.9-2.3-2.1-2.3c-1,0-2.1,0.7-2.1,2.2c0,1.6,1,2.3,2.1,2.3    C89.4,35.8,90.3,34.9,90.3,33.6z"/>
		<path class="st5" d="M97.4,34.1v-4h1.5v4.1c0,1,0.7,1.6,1.6,1.6c0.8,0,1.5-0.6,1.5-1.6v-4.1h1.5v4c0,1.9-1.3,3-3,3    C98.7,37.2,97.4,36,97.4,34.1z"/>
		<path class="st5" d="M104.8,35.8l0.8-0.9c0.5,0.6,1.1,1,1.9,1c0.6,0,1.1-0.3,1.1-0.8c0-0.4-0.4-0.6-1-0.9L107,34    c-1.1-0.5-1.8-1-1.8-2c0-1.3,1.1-2,2.4-2c1,0,1.8,0.4,2.4,1.1l-0.8,0.9c-0.4-0.4-1-0.7-1.6-0.7c-0.5,0-0.9,0.2-0.9,0.7    c0,0.4,0.3,0.5,0.9,0.8l0.7,0.3c1.2,0.5,1.9,1.1,1.9,2.1c0,1.4-1.2,2.1-2.5,2.1C106.3,37.2,105.3,36.6,104.8,35.8z"/>
	</g>
</g>
</svg>
    </a>

    <main class="n-main-container">
      <slot />
    </main>

    <Theme6BaseTheFooter />
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import IndexGlobal from '~/mixins/index.global';
import LayoutsMixin from '~/mixins/layouts.mixin';
import { useWebsiteStore } from '~/units/website/store';
import AvailableComponentsForTheme6 from '~/components/theme6/AvailableComponentsForTheme6.vue';
import { useAppMode } from '~/composables';

export default defineNuxtComponent({
  name: 'Theme6',

  mixins: [IndexGlobal, LayoutsMixin],

  components: { AvailableComponentsForTheme6 },

  data() {
    return {
      containers: [
        {
          name: 'BLOGS_VIEW',
          classes: 'blog-wrap5',
        },
        {
          name: 'BLOG_DETAIL_VIEW',
          classes: 'blog-wrap6',
        },
      ],
    };
  },

  head(context) {
    const appMode = useAppMode();

    if (appMode.server && context.ssrContext) {
      const websiteStore = useWebsiteStore();
      const isNicholsons = websiteStore.companyKey === 'nicholsonsestateagents';
      const isHarrisonsHomes = websiteStore.companyKey === 'harrisonshomes';
      const tagScripts = (() => {
        if (process.env.APP_STAGE === 'production') {
          return [
            ...websiteStore.googleTagsScripts,
            {
              key: 'company-analytics',
              type: 'text/javascript',
              src: `/trackers/${websiteStore.company?.company_key}.js`,
              async: false,
            },
          ];
        }
        return [];
      })();

      return {
        link: [
          {
            rel: 'stylesheet',
            href: `/theme6/css/${websiteStore.company?.company_key}/index.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme6/css/theme/animate.min.css`,
            type: 'text/css',
          },
          {
            rel: 'stylesheet',
            href: `/theme6/css/theme/odometer.css`,
            type: 'text/css',
          },
          isNicholsons
            ? {
                rel: 'stylesheet',
                href: 'https://cdn.msgboxx.io/static/css/bundle.min.css',
                type: 'text/css',
              }
            : null,
        ],
        script: [
          ...tagScripts,
          isNicholsons
            ? {
                src: 'https://cdn.msgboxx.io/static/js/bundle.min.js',
                async: true,
                onload: "window.msgboxxClient='NICHOLSONS';",
                body: true,
              }
            : null,

          isNicholsons
            ? {
                src: `https://assets.calendly.com/assets/external/widget.js`,
                type: 'text/javascript',
                async: true,
              }
            : null,
              /*
          isHarrisonsHomes
            ? {
                src: `https://d2mpatx37cqexb.cloudfront.net/delightchat-whatsapp-widget/embeds/embed.min.js`,
                type: 'text/javascript',
                async: true,
              }
            : null,
            */
          {
            src: `/theme6/js/vendor/jquery-3.6.0.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/jarallax.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/jarallax-video.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/jquery.odometer.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/jquery.appear.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/jquery.easing.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/slick.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/slick-animation.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/magnific-popup.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/ajax-form.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/wow.min.js`,
            type: 'text/javascript',
            async: false,
          },
          {
            src: `/theme6/js/vendor/main.js`,
            type: 'text/javascript',
            async: false,
          },
        ],
      };
    }
  },

  computed: {
    ...mapState(useWebsiteStore, ['currentPage', 'company']),

    cssVariablesBinding() {
      return {
        ...this.cssVariables,
        '--c-primary': this.colors.primary || '#000000',

        '--akya-text-color': 'var(--c-text-primary)',
        '--akya-background-color': 'var(--c-section_primary)',
        '--akya-confirm-button-text-color': 'var(--c-text-secondary)',
        '--akya-confirm-button-background-color': 'var(--c-primary)',
      };
    },

    isNicholsons() {
      return useWebsiteStore().company?.company_key === 'nicholsonsestateagents';
    },

    isHarrisonsHomes() {
      return useWebsiteStore().company?.company_key === 'harrisonshomes';
    },

    shouldShowComponent() {
      const currentPath = this.$route.path;
      const isInHeadsUpAlerts = currentPath.startsWith('/heads-up-alerts');
      return this.isNicholsons && !isInHeadsUpAlerts;
    },

    shouldHideWhatsApp() {
      const currentPath = this.$route.path;
      return currentPath.startsWith('/heads-up-alerts/register');
    },
  },
});
</script>
